module.exports = "/_next/static/images/subscription-11a1cfa08ec0a59677685f2efd35b53b.svg";